
import { createClient } from '@supabase/supabase-js';
import { CONFIG } from './config';

/**
 * Inicialização do cliente principal.
 * Consome configurações resolvidas pelo config.ts
 */
const initializeSupabase = () => {
  const { supabaseUrl, supabaseAnonKey } = CONFIG;

  if (!supabaseUrl || !supabaseAnonKey) {
    const missingVars = [];
    if (!supabaseUrl) missingVars.push('VITE_SUPABASE_URL');
    if (!supabaseAnonKey) missingVars.push('VITE_SUPABASE_ANON_KEY');

    const errorMsg = `Servidor não configurado. Faltando: ${missingVars.join(', ')}`;
    console.error(`[Supabase] ${errorMsg}`);

    // Stub de segurança para evitar crashes e exibir erro claro no login
    const databaseStub = () => ({
      select: () => databaseStub(),
      eq: () => databaseStub(),
      update: () => databaseStub(),
      insert: () => databaseStub(),
      in: () => databaseStub(),
      or: () => databaseStub(),
      gte: () => databaseStub(),
      order: () => databaseStub(),
      maybeSingle: async () => ({ data: null, error: new Error(errorMsg) }),
      then: (cb: any) => Promise.resolve({ data: [], error: null }).then(cb),
    });

    return {
      auth: {
        getSession: async () => ({ data: { session: null }, error: null }),
        getUser: async () => ({ data: { user: null }, error: null }),
        onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
        signInWithPassword: async () => ({ data: { user: null, session: null }, error: new Error(errorMsg) }),
        signUp: async () => ({ data: { user: null, session: null }, error: new Error(errorMsg) }),
        signOut: async () => ({ error: null }),
        resetPasswordForEmail: async () => ({ error: new Error(errorMsg) }),
        refreshSession: async () => ({ data: { session: null, user: null }, error: new Error(errorMsg) }),
      },
      from: () => databaseStub(),
      functions: {
        invoke: async () => ({ data: null, error: new Error(errorMsg) }),
      },
      channel: () => ({ on: () => ({ subscribe: () => ({}) }) }),
      removeChannel: () => {},
    } as any;
  }

  console.log('[Supabase] Initializing singleton client...');
  
  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'gd-supabase-auth',
      lock: async (name, acquireTimeout, fn) => {
        // Bypass Navigator LockManager to prevent timeout errors in iframe/preview
        return await fn();
      },
    },
  });
};

// Exporta uma única instância
export const supabase = initializeSupabase();
